import { GlDisclosureDropdown, GlIcon, GlSearchBoxByType, GlSprintf } from '@gitlab/ui';
import fuzzaldrinPlus from 'fuzzaldrin-plus';
import { __, n__, s__, sprintf } from '~/locale';
export const i18n = {
    messageAdditionsDeletions: s__('Diffs|with %{additions} and %{deletions}'),
    noFilesFound: __('No files found.'),
    noFileNameAvailable: s__('Diffs|No file name available'),
    searchFiles: __('Search files')
};
const variantCssColorMap = {
    success: 'gl-text-success',
    danger: 'gl-text-danger'
};
export default {
    name: 'DiffStatsDropdown',
    i18n,
    components: {
        GlDisclosureDropdown,
        GlIcon,
        GlSearchBoxByType,
        GlSprintf
    },
    props: {
        changed: {
            type: Number,
            required: true
        },
        added: {
            type: Number,
            required: true
        },
        deleted: {
            type: Number,
            required: true
        },
        files: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            search: ''
        };
    },
    computed: {
        filteredFiles () {
            return this.search.length > 0 ? fuzzaldrinPlus.filter(this.files, this.search, {
                key: 'name'
            }) : this.files;
        },
        dropdownItems () {
            return this.filteredFiles.map((file)=>{
                return {
                    ...file,
                    text: file.name || this.$options.i18n.noFileNameAvailable,
                    iconColor: variantCssColorMap[file.iconColor]
                };
            });
        },
        messageChanged () {
            return sprintf(n__('Diffs|Showing %{dropdownStart}%{count} changed file%{dropdownEnd}', 'Diffs|Showing %{dropdownStart}%{count} changed files%{dropdownEnd}', this.changed), {
                count: this.changed
            });
        }
    },
    methods: {
        focusInput () {
            this.$refs.search.focusInput();
        },
        focusFirstItem () {
            if (!this.filteredFiles.length) return;
            this.$el.querySelector('.gl-new-dropdown-item:first-child').focus();
        },
        additionsText (numberOfChanges = this.added) {
            return n__('Diffs|%d addition', 'Diffs|%d additions', numberOfChanges);
        },
        deletionsText (numberOfChanges = this.deleted) {
            return n__('Diffs|%d deletion', 'Diffs|%d deletions', numberOfChanges);
        }
    }
};
